const APP_NAME = "Flux Orders";

const EXACT_ROUTES = {
  "/dashboard": "Dashboard",
  "/my-account": "My Account",
  "/customers": "Manage Customers",
  "/customers/new": "New Customer",
  "/customer-groups": "Manage Groups",
  "/customer-groups/new": "New Customer Group",
  "/products": "Manage Products",
  "/products/create": "New Product",
  "/primary-categories": "Primary Categories",
  "/primary-categories/new": "New Primary Category",
  "/sub-categories": "Sub Categories",
  "/sub-categories/new": "New Sub Category",
  "/create-order": "Create Order",
  "/orders": "Manage Orders",
  "/expenses": "Manage Expenses",
  "/loblaws-skus": "Loblaws Skus",
  "/shippings": "Shipping History",
  "/create-shipping": "Create Shipping",
  "/cart": "Cart",
  "/users": "Users",
  "/users/new": "New User",
  "/tenants": "Tenants",
  "/tenants/new": "New Tenant",
  "/quickbooks-login": "Quickbooks",
  "/quickbooks/callback": "Quickbooks",
  "/login": "Login",
};

const PARAM_ROUTES = [
  { prefix: "/customers/", title: "Customer Details" },
  { prefix: "/customer-groups/", title: "Customer Group Details" },
  { prefix: "/products/", title: "Product Details" },
  { prefix: "/primary-categories/", title: "Category Details" },
  { prefix: "/sub-categories/", title: "Sub Category Details" },
  { prefix: "/orders/", title: "Order Details" },
  { prefix: "/shippings/", title: "Shipping Details" },
  { prefix: "/users/", title: "User Details" },
  { prefix: "/tenants/", title: "Tenant Details" },
];

export function getPageTitle(pathname) {
  const exact = EXACT_ROUTES[pathname];
  if (exact) {
    return `${exact} | ${APP_NAME}`;
  }

  for (const { prefix, title } of PARAM_ROUTES) {
    if (pathname.startsWith(prefix)) {
      return `${title} | ${APP_NAME}`;
    }
  }

  return APP_NAME;
}
